export const MOVIES_NOT_FOUND_ERROR_MESSAGE = "Ничего не найдено";
export const REQUEST_ERROR_MESSAGE = "Во время запроса произошла ошибка. Возможно, проблема с соединением или сервер недоступен. Подождите немного и попробуйте ещё раз";
export const DEFAULT_ERROR_MESSAGE = "Что-то пошло не так...";
export const NO_FAVS_ERROR_MESSAGE = "Вы еще ничего не добавили в избранное.";

export const NAME_ERROR_MESSAGE = "Имя должно содержать только латиницу, кириллицу, пробел или дефис.";
export const EMAIL_ERROR_MESSAGE = "Пожалуйста, введите корректный e-mail.";
export const PASSWORD_ERROR_MESSAGE = "Пожалуйста, введите пароль.";

export const PROFILE_UPDATE_ERROR_MESSAGE = "При обновлении профиля произошла ошибка.";
export const EMAIL_CONFLICT_ERROR_MESSAGE = "Пользователь с таким email уже существует";
export const SIGNUP_ERROR_MESSAGE = "При регистрации пользователя произошла ошибка.";
export const LOGIN_ERROR_MESSAGE = "Вы ввели неправильный логин или пароль.";
export const AUTHORIZATION_ERROR_MESSAGE = "При авторизации произошла ошибка. Токен не передан или передан не в том формате.";
export const INCORRECT_TOKEN_ERROR_MESSAGE = "При авторизации произошла ошибка. Переданный токен некорректен.";
export const SERVER_ERROR_MESSAGE = "На сервере произошла ошибка.";
export const NOT_FOUND_ERROR_MESSAGE = "Страница по указанному маршруту не найдена.";
